import en from './en.json';
import ro from './ro.json';

const messages = { en, ro };

export default { messages, invariant: 'en' };



// WEBPACK FOOTER //
// ./src/app/@remax-ro/locales/index.js